(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  define('pricelist/views/SideBarView',["jquery", "backbone", "commons/views/SlideView", "commons/views/EditorialScheduleView", "hbs!pricelist/templates/side-bar", "hbs!pricelist/templates/discount", "hbs!pricelist/templates/addition", "hbs!pricelist/templates/supplement", "hbs!pricelist/templates/information", "hbs!pricelist/templates/booking", "hbs!pricelist/templates/technical"], function($, Backbone, SlideView, EditorialScheduleView, sideBarTemplate, discountTemplate, additionTemplate, supplementTemplate, informationTemplate, bookingTemplate, technicalTemplate) {
    var $container, View, isFull, isPrint, mediaId, moduleMap;
    $container = $("#container");
    isFull = /proof/i.test(window.location.search);
    isPrint = $container.data("mediagroup") === "print";
    mediaId = $container.data("mediaid");
    moduleMap = $container.data("modulemap");
    return View = (function(superClass) {
      extend(View, superClass);

      function View() {
        this.render = bind(this.render, this);
        return View.__super__.constructor.apply(this, arguments);
      }

      View.prototype.el = "div#controls";

      View.prototype.initialize = function() {
        this.template = sideBarTemplate;

        /* Create the different lightbox views that the side bar should hold */
        this.discountLightbox = new SlideView({
          priceList: this.model,
          url: "/Print/PriceList/Discounts/",
          contentTemplate: discountTemplate
        });
        this.additionLightbox = new SlideView({
          priceList: this.model,
          url: "/Print/PriceList/Additions/",
          contentTemplate: additionTemplate
        });
        this.supplementLightbox = new SlideView({
          priceList: this.model,
          url: "/Print/PriceList/Supplements/",
          contentTemplate: supplementTemplate
        });
        this.technicalLightbox = new SlideView({
          id: mediaId,
          url: "/Digital/PriceList/Technical/",
          contentTemplate: technicalTemplate
        });
        if ((mediaId != null) && mediaId !== 0) {
          this.informationLightbox = new SlideView({
            id: mediaId,
            url: isPrint ? "/Print/PriceList/MediaTexts/" : "/Digital/PriceList/MediaTexts/",
            contentTemplate: informationTemplate,
            respWrapper: "information"
          });
        }
        if (!isPrint) {
          this.bookingLightbox = new SlideView({
            priceList: this.model,
            url: "/??",
            contentTemplate: bookingTemplate
          });
        }
        return this.editorialscheduleLightbox = new EditorialScheduleView();
      };

      View.prototype.bindings = function() {
        return this.model.on("change:layout", this.render);
      };

      View.prototype.render = function() {
        this.bindings();
        this.$el.html(sideBarTemplate({
          hasMediaId: (mediaId != null) && mediaId !== 0,
          isPrint: isPrint,
          moduleMap: moduleMap
        }));
        this.setSettings();
        if (isFull) {
          this.showDiscounts();
          this.showAdditions();
          this.showSupplements();
          this.showEditorialschedule();
          this.showInformation();
          this.showTechnical();
        }
        return this;
      };

      View.prototype.events = {
        "change #section-first, #position-first, #format-first": "sort",
        "click #discount": "showDiscounts",
        "click #addition": "showAdditions",
        "click #supplement": "showSupplements",
        "click #editorialschedule": "showEditorialschedule",
        "click #information": "showInformation",
        "click #booking": "showBooking",
        "click #technical": "showTechnical"
      };

      View.prototype.sort = function() {
        this.model.layout(this.$("div:last input:checked").val());
        return app.router.navigate((this.model.get("id")) + "/" + this.model.get("layout"));
      };

      View.prototype.showDiscounts = function() {
        return this.discountLightbox.open();
      };

      View.prototype.showAdditions = function() {
        return this.additionLightbox.open();
      };

      View.prototype.showSupplements = function() {
        return this.supplementLightbox.open();
      };

      View.prototype.showEditorialschedule = function() {
        this.editorialscheduleLightbox.open();
        return this.editorialscheduleLightbox.show();
      };

      View.prototype.showInformation = function() {
        var ref;
        return (ref = this.informationLightbox) != null ? ref.open() : void 0;
      };

      View.prototype.showBooking = function() {
        return this.bookingLightbox.open();
      };

      View.prototype.showTechnical = function() {
        return this.technicalLightbox.open();
      };

      View.prototype.setSettings = function() {
        switch (this.model.get("layout")[0]) {
          case "S":
            return this.$("#section-first").prop("checked", true);
          case "P":
            return this.$("#position-first").prop("checked", true);
          case "F":
            return this.$("#format-first").prop("checked", true);
          default:
            return null;
        }
      };

      return View;

    })(Backbone.View);
  });

}).call(this);

//# sourceMappingURL=SideBarView.js.map
;
